import React, { useMemo } from 'react';

import clsxm from '@/lib/clsxm';

import MoneyFormat from '@/components/MoneyFormat';
import Typography from '@/components/typography';

import { Job } from '@/services/public-jobs.service';
import { routes } from '@/utils/route-utils';
import { getStateFullNameFromAbbr } from '@/utils/state-utils';

export type CardLocationProps = {
  location: Job['location'];
  weeklyPay: Job['weeklyPay'];
  discipline: Job['disciplineTitle'];
  hasImage?: boolean;
  locationApiId: string;
  disciplineApiId: Job['discipline'];
  className?: string;
};

export default function CardLocation({
  weeklyPay,
  locationApiId,
  disciplineApiId,
  className,
  hasImage,
  discipline,
}: CardLocationProps) {
  const locationTitle = useMemo<string>(() => {
    if (/,/.test(locationApiId)) {
      return locationApiId;
    }

    return getStateFullNameFromAbbr(locationApiId);
  }, [locationApiId]);

  const jobSearchUrl = routes.jobSearch({
    locations: locationApiId,
    discipline: disciplineApiId,
  });

  return (
    <a
      className={clsxm(
        'flex min-h-[182px] flex-shrink-0 overflow-hidden rounded-lg bg-primary-light',
        className
      )}
      href={jobSearchUrl}
    >
      <div className='flex min-w-[250px] flex-col justify-center py-6 pl-4 pr-8 sm:pr-4 md:min-w-[320px]'>
        <Typography.Subtitle3 weight='normal'>Up to</Typography.Subtitle3>
        <Typography.Heading6
          weight='bold'
          className='mt-1 whitespace-nowrap'
          family='dm-sans'
        >
          <MoneyFormat value={weeklyPay} />
          /wk
        </Typography.Heading6>
        <Typography.Subtitle2 className='mt-2' weight='bold'>
          {locationTitle}
        </Typography.Subtitle2>

        <Typography.Subtitle2 className='mt-2' weight='normal' family='dm-sans'>
          {discipline}
        </Typography.Subtitle2>

        <div className='mt-2 flex'>
          <button
            className='w-auto rounded-lg border border-black bg-transparent px-8 py-1 leading-[22px] text-black'
            type='button'
          >
            <Typography.Button4 as='span'>Details</Typography.Button4>
          </button>
        </div>
      </div>

      {hasImage && (
        <div
          className='min-h-full w-40 bg-cover bg-center'
          style={{
            backgroundImage: `url('/images/job-blocks-location-image.jpg')`,
          }}
        />
      )}
    </a>
  );
}
